import React from 'react';
import "./Note.scss"

const Note = () => {
  const [showNote,setShowNote] = React.useState(true)
  return (
    <div  className={`${showNote ? "noteWrapper":"hide"}`}>
        <div className="noteContainer">
          <span onClick={() => setShowNote(!showNote)}  className={`${"noteClose"}`}>&#10006;</span>
           <img src="./brain.png" alt="svg brain" className="noteImg" />
           <p className="noteText">
            This application uses firebase services which may be blocked in some countries! use a VPN
             if you faced troubles registering, signing in or uploading images.
           </p>
        </div>
    </div>
  )
}

export default Note